// extracted by mini-css-extract-plugin
export default {"component":"MarketButton_component__Llwf-","isOff":"MarketButton_isOff__RXmFZ","isOn":"MarketButton_isOn__R3Q3G"};